export const BASE_URL = 'account/team';

export const URL_ROOT = `${BASE_URL}`;
export const URL_EDIT_USER_DETAILS = `${BASE_URL}/edit/:id`;
export const URL_ADD_USER = `${BASE_URL}/add`;

export const URL_HIRER_GRAPH = '/graphql';
export const URL_HIRER_GRAPH_LOCAL = `http://localhost:4000${URL_HIRER_GRAPH}`;
export const URL_HIRER_GRAPH_STAGING = `https://talent.staging.seek.com.au${URL_HIRER_GRAPH}`;

export const URL_ERROR_FORBIDDEN = '/error/forbidden';
